import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import { InputWithLabel } from "../../component/Form/InputWithLabel";
import {timeago} from "../../utils/dates";

class MovementOrderGrid {
  title = 'Lista de Ordens de Movimentações';

  exportNewPage = true;

  showPdfButton = false;

  columns = [
    {
      Header: "Código",
      accessor: "code",
      HeaderColumn: true
    },
    {
      Header: "Produtos",
      accessor: "products.length",
      Cell: row => (
          row.original.products && row.original.products.length
      )
    },
    {
      Header: "Criado em",
      accessor: "createdAt",
      Cell: row => (
          timeago(row.original.createdAt)
      )
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row className="justify-content-center">
            <Col sm={6} md={6}>
              <Button block href={`#/movement-order/${row.original.id}`}
                      bsStyle="secondary">Visualizar</Button>
            </Col>
          </Row>
      )
    }
  ];

  customFilters = { friendlyName: null }

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Código da ordem de movimentação" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const { friendlyName } = this.customFilters

    friendlyName && params.append('code', friendlyName)

    return `ton/v1/movement-orders?${params.toString()}`
  }

}

export default MovementOrderGrid;



// WEBPACK FOOTER //
// ./src/movementOrder/component/MovementOrderGrid.js